import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import loadable from '@loadable/component'

import gameImg1 from "../../assets/images/games/samplegameImg.png";
import { getCloudFrontSourcePath } from "../../utils/functions";
import { usePageMeta } from "../../utils/pageMeta";
import { gateCategoryDetailAction } from "../../redux/actions/categoryActions";

const GameCard = loadable(() => import('../../components/UI/GameCard'))
const GameGridWithAd = loadable(() => import('../../components/UI/GameGridWithAd'))
const AdBanner = loadable(() => import('../../components/UI/AdBanner'))
const Loader = loadable(() => import('../../components/UI/Loader'))

const CategoryAllGames = () => {
	const CategoryState = useSelector((state) => state.Category);
	const dispatch = useDispatch();
	const { categoryid } = useParams();
	const { categoryViewDetails, loading } = CategoryState;

	useEffect(() => {
		dispatch(gateCategoryDetailAction({ cat_id: categoryid }));
	}, [categoryid, dispatch]);

	let gameData = categoryViewDetails?.apps ? categoryViewDetails?.apps : [];
	const isStale = categoryViewDetails?.id
		&& String(categoryViewDetails.id) !== String(categoryid);

	usePageMeta({
		title: !isStale && categoryViewDetails?.name ? `All ${categoryViewDetails.name} Games | Akedo` : "",
		description: categoryViewDetails?.description || categoryViewDetails?.desc,
		path: `/category/${categoryid}/games`,
	});

	let cloudFrontSourcePath = getCloudFrontSourcePath();

	return (
		<section className="viewAllGame gridPageContent px-0 py-[30px]">
			{(loading || isStale) && <Loader isTranserent={true} />}
			{!isStale && <div className="container">
				<div className="text-center">
					<h2 className="text-[#fff] text-[28px] tracking-widest mb-4">
						{categoryViewDetails?.name}
					</h2>
				</div>
				<GameGridWithAd
					items={gameData}
					renderItem={(game, index) => <GameCard keyIndex={index} img={ game?.icon ? `${cloudFrontSourcePath}${game?.icon}` : gameImg1 } game={game} key={`category_allgame_${index}`} subtitle={categoryViewDetails?.name} />}
				/>
				{!loading && gameData.length > 0 && <AdBanner key={categoryid} placement="grid-bottom" />}
			</div>}
		</section>
	);
};

export default React.memo(CategoryAllGames);
